import React, { useState, useEffect } from 'react';
import ContinueButton from './ContinueButton';

interface SplashPageProps {
  title: string;
  subtitle?: string;
  onContinue: () => void;
}

const SplashPage: React.FC<SplashPageProps> = ({ title, subtitle, onContinue }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const duration = 4700;

    let animationFrame: number;
    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);
      if (newProgress < 100) {
        animationFrame = requestAnimationFrame(updateProgress);
      }
    };
    animationFrame = requestAnimationFrame(updateProgress);
    return () => cancelAnimationFrame(animationFrame);
  }, []);
  return (
    <div className="splash-content">
      <div className="title-wrapper">
        <div className="heading-container">
          <h1 className="splash-title" dangerouslySetInnerHTML={{ __html: title || '' }}></h1>
        </div>
        {subtitle && (
          <p className="splash-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
        )}
      </div>

      <div className="splash-image">
        <img
          src="/image/start_image.webp"
          alt="Age Back app preview"
          onError={(e) => {
            console.error('Failed to load image:', e.currentTarget.src);
            e.currentTarget.style.backgroundColor = '#f0f0f0';
            e.currentTarget.style.display = 'block';
          }}
        />
      </div>

      <div className="splash-bottom">
        {progress >= 100 ? (
          <ContinueButton onClick={onContinue} />
        ) : (
        <div className="progress-section">
          <div className="progress-bar-container">
            <div className="progress-bar-bg">
              <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
              <div className="progress-percentage">{Math.round(progress)}%</div>
            </div>
          </div>
          <div className="loading-text">Loading the quiz</div>
        </div>
        )}
      </div>
    </div>
  );
};

export default SplashPage;